module.exports = __webpack_public_path__ + "media/public/fonts/QanelasThin/QanelasThin-f89db008537c7bab25a4874e157d01d5.woff";